import { Activity, Clock, Pause, Timer } from "lucide-react";
import { comparisonLabel } from "./dateRange";
import { formatDuration } from "./formatters";
import { kpiTrend } from "./kpiTrend";

export default function IndividualKpiCards({ kpis, preset, periodLabel, avgPerDay }) {
  const avgTrend = kpiTrend(
    kpis.avgSessionSeconds,
    kpis.priorAvgSessionSeconds,
    comparisonLabel(preset),
    { duration: true },
  );

  const cards = [
    {
      key: "active",
      label: "Active time",
      tone: "active",
      Icon: Activity,
      value: formatDuration(kpis.activeSeconds),
      meta: periodLabel,
      metaTone: "flat",
    },
    {
      key: "sessions",
      label: "Sessions",
      tone: "sessions",
      Icon: Timer,
      value: kpis.sessionCount,
      meta: `Avg ${avgPerDay} per day`,
      metaTone: "flat",
    },
    {
      key: "avg",
      label: "Avg session",
      tone: "avg",
      Icon: Clock,
      value: formatDuration(kpis.avgSessionSeconds),
      meta: `${avgTrend.tone === "up" ? "↑ " : avgTrend.tone === "down" ? "↓ " : ""}${avgTrend.text}`,
      metaTone: avgTrend.tone,
    },
    {
      key: "pause",
      label: "Pause time",
      tone: "pause",
      Icon: Pause,
      value: formatDuration(kpis.pauseSeconds),
      meta: `Manual ${formatDuration(kpis.manualPauseSeconds)} · Auto ${formatDuration(kpis.autoPauseSeconds)}`,
      metaTone: "flat",
    },
  ];

  return (
    <section className="pa-kpi-board pa-kpi-board--row" aria-label="Summary">
      {cards.map((card) => {
        const Icon = card.Icon;
        return (
          <article key={card.key} className={`pa-kpi-card pa-kpi-card--${card.tone}`}>
            <div className="pa-kpi-card__top">
              <p className="pa-kpi__label">{card.label}</p>
              <span className="pa-kpi-card__icon" aria-hidden="true">
                <Icon size={16} />
              </span>
            </div>
            <p className="pa-kpi-card__value">{card.value}</p>
            <p className={`pa-kpi-card__trend pa-kpi-card__trend--${card.metaTone}`}>{card.meta}</p>
          </article>
        );
      })}
    </section>
  );
}
